import api from "./api-utils.js";

/**
 * @typedef {Object} UserAccess
 * @property {boolean} canRunRcaAi - Session-tenant permission for LLM shutdown analysis.
 * @property {boolean} showRcaAi - When false, hide all RCA AI UI; omitted or true keeps current behavior.
 * @property {boolean} isOneViewAdmin - When true, show all admin UI
 */

/**
 * Fetch tenant-scoped user access flags for the current session.
 * @returns {Promise<UserAccess>}
 */
export async function getUserAccess() {
  const { data } = await api.get("/api/user/access");
  return {
    canRunRcaAi: Boolean(data?.CanRunRCA_AI_Models),
    showRcaAi: data?.RCAiAuthorized !== false,
    isOneViewAdmin: data?.IsOneViewAdmin === true,
  };
}
